import { pushModal } from '../Modals/redux/basicActions';
import { VerificationRequiredActions } from '../publicSession/types';
import { ModalType } from '../Modals/redux/types';

export const pushVerificationPopup = (actionType?: VerificationRequiredActions) =>
  pushModal(ModalType.VERIFICATION, {
    params: { actionType },
    wrapInModal: false,
  });
